import { render, staticRenderFns } from "./ArchitectPassport.vue?vue&type=template&id=f9818718&scoped=true&"
import script from "./ArchitectPassport.vue?vue&type=script&lang=js&"
export * from "./ArchitectPassport.vue?vue&type=script&lang=js&"
import style0 from "./ArchitectPassport.vue?vue&type=style&index=0&id=f9818718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9818718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
